import { initializePermissionApi, PermissionApi } from '@data-delivery/permission-ui-api';
import { queryOptions } from '@tanstack/react-query';

const businessGroupsApi = initializePermissionApi(PermissionApi.BusinessGroupsApi);

export const businessGroupsKeys = {
  all: () => ['business-groups'] as const,

  list: () => [...businessGroupsKeys.all(), 'list'] as const,
  listQuery: () =>
    queryOptions({
      queryKey: businessGroupsKeys.list(),
      async queryFn() {
        const { data } = await businessGroupsApi.getOrSearchBusinessGroups({});
        return data;
      },
    }),

  searchByName: (name: string) => [...businessGroupsKeys.all(), 'search-name', name] as const,
  searchByNameQuery: (name: string) =>
    queryOptions({
      queryKey: businessGroupsKeys.searchByName(name),
      async queryFn() {
        const { data } = await businessGroupsApi.getOrSearchBusinessGroups({ name });
        return data;
      },

      enabled: name.trim().length > 0,
    }),

  byId: (id: string) => [...businessGroupsKeys.all(), 'by-id', id] as const,
  byIdQuery: (id: string) =>
    queryOptions({
      queryKey: businessGroupsKeys.byId(id),
      async queryFn() {
        const { data } = await businessGroupsApi.getOrSearchBusinessGroups({ id });

        return Array.isArray(data) ? data[0] : data;
      },
      enabled: Boolean(id),
    }),
};

export type BusinessGroupEntity = PermissionApi.BusinessGroupEntity;
